import styled from 'styled-components/macro'

const TreasureGridWrapper = styled('div')`
  margin-top: 24px;
`

export default TreasureGridWrapper
